import { z } from "zod";

import { personaEnum } from "../types/enums";

import { shippingAddressSchema, billingAddressSchema } from "./primitives";

export const userFormDataSchema = z.object({
  firstName: z.string().optional(),
  lastName: z.string().optional(),
  email: z.string().optional(),
  phoneNumber: z.string().optional(),
  marketingConsent: z.boolean().optional(),
  shippingAddress: shippingAddressSchema.optional(),
  billingAddress: billingAddressSchema.optional(),
  id: z.string().optional(),
  oldId: z.string().optional(),
  persona: personaEnum.optional(),
});

export type TUserFormData = z.infer<typeof userFormDataSchema>;
export type TUserFormDataInput = z.input<typeof userFormDataSchema>;
